<template>
  <div>
    <mt-button class="mb15">
      <el-button @click="onAddBtnClick" type="primary">新增</el-button>
      <el-button @click="onRefreshBtnClick">刷新</el-button>
    </mt-button>
    <el-table
      ref="visitTable"
      :data="slaughterhouseList"
      stripe
      :height="tableHeight"
      :maxHeight="tableHeight"
      style="width: 100%;">
      <el-table-column
        header-align="left"
        type="index"
        label="#"
        :index="formatterIndex"
        width="50">
      </el-table-column>
      <el-table-column
        header-align="left"
        align="left"
        prop="name"
        label="名称">
      </el-table-column>
      <el-table-column
        header-align="left"
        align="left"
        prop="chargePerson"
        label="管理员">
      </el-table-column>
      <el-table-column
        header-align="left"
        align="left"
        width="300"
        prop="address"
        label="地址">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        width="100"
        label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button @click.stop="onEditBtnClick(scope.row)" type="primary" icon="el-icon-edit" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button @click.stop="onDeleteBtnClick(scope.row)" type="danger" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="onPageChange"
      layout="->, total, prev, pager, next"
      :page-size="pageSize"
      :current-page="pageIndex"
      :total="slaughterhouseTotal"
      class="pagination">
    </el-pagination>

    <el-dialog :title="model.id === 0 ? '新增屠宰场' : '编辑屠宰场'" :visible.sync="dialogVisible" width="50%">
      <el-form :rules="rules" ref="dataForm" :model="model" label-position="left" label-width="100px" class="data-form"
               style='width: 500px; margin:0 auto;'>
        <el-form-item label="名称" prop="name">
          <el-input v-model="model.name"></el-input>
        </el-form-item>
        <el-form-item label="管理员" prop="chargePerson">
          <el-input v-model="model.chargePerson"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="model.address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editSupplier">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import MtButton from '../../components/mt-button'
  import {apiGetSlaughterhouseList, apiEditSlaughterhouse, apiDeleteById} from '../../api/slaughterhouse'
  import {tableMixin} from '../../mixins/table'

  export default {
    name: 'TraceSlaughterHouse',
    mixins: [tableMixin],
    components: {MtButton},
    data() {
      return {
        slaughterhouseList: [],
        slaughterhouseTotal: 0,
        type: -1,
        dialogVisible: false,
        model: {
          id: 0,
          name: '',
          chargePerson: '',
          address: ''
        },
        rules: {
          name: [{required: true, message: '不能为空', trigger: 'blur'}],
          chargePerson: [{required: true, message: '不能为空', trigger: 'blur'}],
          address: [{required: true, message: '不能为空', trigger: 'blur'}]
        }
      }
    },
    activated() {
      this._getSlaughterhouseList()
    },
    methods: {
      onAddBtnClick() {
        this.dialogVisible = true
        this._clearModel()
        this._resetModel()
      },
      onEditBtnClick(row) {
        this._clearModel()
        this.dialogVisible = true
        this.model = Object.assign({}, this.model, row)
      },
      onRefreshBtnClick() {
        this._getSlaughterhouseList()
      },
      editSupplier() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            apiEditSlaughterhouse(this.model).then(({data}) => {
              this.pageIndex = 1
              this._getSlaughterhouseList()
              this.dialogVisible = false
              this.$message({
                type: 'success',
                message: this.model.id === 0 ? '添加成功' : '修改成功'
              })
              this._resetModel()
            })
          }
        })
      },
      onDeleteBtnClick(row) {
        this.$confirm('是否确认删除该屠宰场？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDeleteById(row.id).then(data => {
            this._getSlaughterhouseList()
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          })
        })
      },
      onPageChange(val) {
        this.pageIndex = val
        this._getSlaughterhouseList()
      },
      _clearModel() {
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      _resetModel() {
        this.model = {
          id: 0,
          name: '',
          chargePerson: '',
          address: ''
        }
      },
      _getSlaughterhouseList(pageIndex = this.pageIndex) {
        apiGetSlaughterhouseList(pageIndex).then(({data}) => {
          this.slaughterhouseList = data.data
          this.slaughterhouseTotal = data.total
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

</style>
